import Toast, { ToastVariants } from '@features/ui-atoms/components/Toast';
import { BodyWrapper } from '@features/ui-layout/components/ResponsiveWrappers';
import { useToastStore } from '@root/src/stores/useToastStore';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { ReactNode } from 'react';

interface LayoutLoggedoutProps {
  children: ReactNode;
  title: string;
}

const MainWrapper = ({ children, title }: LayoutLoggedoutProps): JSX.Element => {
  const { t } = useTranslation();
  const { openToast, resetToast } = useToastStore();
  return (
    <>
      <Head>
        <title>{t(title)}</title>
      </Head>
      <BodyWrapper>
        {children}

        {openToast.o && (
          <Toast
            title={openToast.title ?? ''}
            message={openToast.message}
            variant={openToast.variant ?? ToastVariants.ERROR}
            onClose={() => resetToast()}
          />
        )}
      </BodyWrapper>
    </>
  );
};

export default MainWrapper;
